import { Flexbox } from '@sede-enterprise/shell-ds-react-framework';
import { GAS_FIRED_GENERATION } from '../../../../api/constants';
import { IDealDetails, IGroupNCI, IKpiModal } from '../../../../types/types';
import { getMaxValue, getUniqueTechSource, setUpKpiMessage } from '../DealDetailFunctions';
import SummaryMessage from './SummaryMessage/SummaryMessage';
import '../../AllDeals.css';
import SummaryTable from './SummaryTable/SummaryTable';
import { two } from '../../../../constants';

const KpiSummary = (props: {
  dealDetailsData: IDealDetails[];
  netCarbonIntensityData: IGroupNCI[];
  kpiTableData: IKpiModal[];
}) => {
  const { dealDetailsData, netCarbonIntensityData, kpiTableData } = props;
  // Prefer API-provided summary KPIs if available; otherwise fall back to calculated values
  let maxEquityScope = undefined;
  let maxNetAbsoluteEmission = undefined;
  let maxMCR = undefined;
  const hasApiSummary = Array.isArray(dealDetailsData) && dealDetailsData.length > 0 && (dealDetailsData.some(d => ((d as unknown) as Record<string, unknown>)['EQUITY_SCOPE_CARBON_PEAK_ANNUAL_EMISSION'] !== undefined) || dealDetailsData.some(d => ((d as unknown) as Record<string, unknown>)['NET_ABS_EMISSION_SCOPE_PEAK_ANNUAL_EMISSION'] !== undefined) || dealDetailsData.some(d => ((d as unknown) as Record<string, unknown>)['MCR'] !== undefined));
  if (hasApiSummary) {
    const equityVals = dealDetailsData.map(d => Number(((d as unknown) as Record<string, unknown>)['EQUITY_SCOPE_CARBON_PEAK_ANNUAL_EMISSION'] ?? 0));
    const netAbsVals = dealDetailsData.map(d => Number(((d as unknown) as Record<string, unknown>)['NET_ABS_EMISSION_SCOPE_PEAK_ANNUAL_EMISSION'] ?? ((d as unknown) as Record<string, unknown>)['NET_ABSOLUTE_EMISSION'] ?? 0));
    const mcrVals = dealDetailsData.map(d => Number(((d as unknown) as Record<string, unknown>)['MCR'] ?? ((d as unknown) as Record<string, unknown>)['MARGIN_TO_CARBON_RATIO_AVG'] ?? 0));
    maxEquityScope = {
      value: Math.max(...equityVals),
      unit: dealDetailsData[0]?.CARBON_EMISSIONS_UNIT ?? 'mtpa',
    };
    maxNetAbsoluteEmission = {
      value: Math.max(...netAbsVals),
      unit: dealDetailsData[0]?.CARBON_EMISSIONS_UNIT ?? 'mtpa',
    };
    maxMCR = {
      value: Math.max(...mcrVals),
      unit: dealDetailsData[0]?.UOM ?? '$/tCO2e',
    };
  } else {
    const { maxEquityScope: me, maxNetAbsoluteEmission: mn, maxMCR: mm } = getMaxValue(dealDetailsData);
    maxEquityScope = me;
    maxNetAbsoluteEmission = mn;
    maxMCR = mm;
  }
  const { EFFICIENCY, OPERATING_MODEL, ASSET_TYPE, TRADE_COMMODITY_ID } = dealDetailsData[0];
  const uniqueTechSource = TRADE_COMMODITY_ID === two ? getUniqueTechSource(dealDetailsData) : [];
  const isGasFiredPower = uniqueTechSource.includes(GAS_FIRED_GENERATION);

  const kpiMessage = setUpKpiMessage(
    maxNetAbsoluteEmission?.value ?? 0,
    EFFICIENCY ?? 0,
    Number(OPERATING_MODEL) || 0,
    ASSET_TYPE ?? '',
  );

  return (
    <Flexbox gap='20px'>
      <SummaryTable
        maxEquityScope={maxEquityScope}
        maxNetAbsoluteEmission={maxNetAbsoluteEmission}
        maxMCR={maxMCR}
        netCarbonIntensityData={netCarbonIntensityData}
        dealDetailsData={dealDetailsData}
        kpiTableData={kpiTableData}
      />
      {kpiMessage && (
        <SummaryMessage
          kpiMessage={kpiMessage}
          isGasFiredPower={isGasFiredPower}
          operatingModel={Number(OPERATING_MODEL)}
        />
      )}
    </Flexbox>
  );
};

export default KpiSummary;
